export default __webpack_public_path__ + "static/media/weather.afcd12ff.PNG";